/**
 * staff dashboard service get call all shift api get data from backend.
 */
import { HttpClient, HttpErrorResponse, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { BehaviorSubject, of, Subject } from 'rxjs';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { BlockBookingsResponse } from 'src/app/models/BlockBookingsResponse';
import { IntelyPro } from 'src/app/models/IntelyPro';
import { JavaBaseResponse } from 'src/app/models/shift-management-models/java-base-response';
import { UtilsService } from '../utils/utils.service';
import { PerformanceSummaryShift } from './models/performance-summary-shift.model';

@Injectable({
  providedIn: 'root'
})
export class StaffDashboardService {

  private readonly baseUri = UtilsService.getShiftUri();
  private readonly baseShiftUri = UtilsService.getShiftJavaUri();
  public dashboardShiftsReload$: Subject<void> = new Subject();
  public dashboardShiftData$ = new BehaviorSubject<{
    recentlyAcceptedShifts: IntelyPro[];
    recentlyReleasedShifts: IntelyPro[];
  }>({ recentlyAcceptedShifts: [], recentlyReleasedShifts: [] });

  constructor(
    private _http: HttpClient,
    private _snackbar: MatSnackBar
  ) { }

  /**
   * Reloads dashboard shifts, bu emiting event for repeatWhen.
   */
  reloadDashboardShifts(): void {
    this.dashboardShiftsReload$.next();
  }

  /**
   * Get list of last {days} cancelled shifts.
   * @param hours : hours
   * @param cid : client id
   */
  getLastCancelledShift(days: number, cid: number): Observable<PerformanceSummaryShift> {
    return this.metricsApi('cancelled/last', cid, days);
  }

  /**
   *  Get list of last {days} accepted shifts.
   * @param hours : hours
   * @param cid : client id
   */
  getLastAcceptedShifts(days: number, cid: number): Observable<PerformanceSummaryShift> {
    return this.metricsApi('accepted/last', cid, days);
  }

  /**
   *  Get list of next {hours} accepted shifts.
   * @param hours : hours
   * @param cid : client id
   */
  getNextAcceptedShifts(days: number, cid: number): Observable<PerformanceSummaryShift> {
    const hours = days * 24;
    return this.metricsApi('accepted/next', cid, hours);
  }

  getNextAcceptedBlockShifts(cid: number) {
    return this.metricsApi('block/negotiation/pending', cid);
  }
  /**
   *  Get list of blockBookings.
   * @param cid : client id
   */
  getBlockBookings(id: number): Observable<JavaBaseResponse<BlockBookingsResponse[]>> {
    const params: HttpParams = new HttpParams().append('id', String(id));
    // TODO : for testing only remove later
    // return of({ "data": [ { "blockId": 204, "startDate": "2021-11-18", "endDate": "2021-11-18", "shiftDateRange": "2021-11-18 - 2021-11-18", "status": "Pending", "nurseType": "Nurse", "boostPercentage": 0, "location": "01", "boostable": true }, { "blockId": 205, "startDate": "2021-11-18", "endDate": "2021-11-18", "shiftDateRange": "2021-11-18 - 2021-11-18", "status": "Pending", "nurseType": "Nurse", "boostPercentage": 0, "location": "01", "boostable": true }, { "blockId": 206, "startDate": "2021-11-18", "endDate": "2021-11-18", "shiftDateRange": "2021-11-18 - 2021-11-18", "status": "Pending", "nurseType": "Nurse", "boostPercentage": 0, "location": "01", "boostable": true }, { "blockId": 207, "startDate": "2021-11-18", "endDate": "2021-11-18", "shiftDateRange": "2021-11-18 - 2021-11-18", "status": "Pending", "nurseType": "Nurse", "boostPercentage": 0, "location": "01", "boostable": true }, { "blockId": 208, "startDate": "2021-11-18", "endDate": "2021-11-18", "shiftDateRange": "2021-11-18 - 2021-11-18", "status": "Pending", "nurseType": "Nurse", "boostPercentage": 0, "location": "01", "boostable": true }, { "blockId": 210, "startDate": "2021-11-18", "endDate": "2021-11-18", "shiftDateRange": "2021-11-18 - 2021-11-18", "status": "Pending", "nurseType": "Nurse", "boostPercentage": 0, "location": "01", "boostable": true }, { "blockId": 212, "startDate": "2021-11-18", "endDate": "2021-11-18", "shiftDateRange": "2021-11-18 - 2021-11-18", "status": "Pending", "nurseType": "Nurse", "boostPercentage": 0, "location": "01", "boostable": true }, { "blockId": 213, "startDate": "2021-11-18", "endDate": "2021-11-18", "shiftDateRange": "2021-11-18 - 2021-11-18", "status": "Pending", "nurseType": "Nurse", "boostPercentage": 0, "location": "01", "boostable": true }, { "blockId": 214, "startDate": "2021-11-18", "endDate": "2021-11-18", "shiftDateRange": "2021-11-18 - 2021-11-18", "status": "Pending", "nurseType": "Nurse", "boostPercentage": 0, "location": "01", "boostable": true }, { "blockId": 231, "startDate": "2021-10-10", "endDate": "2021-10-16", "shiftDateRange": "2021-10-10 - 2021-10-16", "status": "Pending", "nurseType": "CNA", "boostPercentage": 0, "location": "01", "boostable": true }, { "blockId": 245, "startDate": "2021-11-15", "endDate": "2021-11-15", "shiftDateRange": "2021-11-15 - 2021-11-15", "status": "Pending", "nurseType": "CNA", "boostPercentage": 0, "location": "01", "boostable": true }, { "blockId": 259, "startDate": "2021-10-05", "endDate": "2021-10-06", "shiftDateRange": "2021-10-05 - 2021-10-06", "status": "Pending", "nurseType": "CNA", "boostPercentage": 0, "location": "01", "boostable": true }, { "blockId": 269, "startDate": "2021-10-08", "endDate": "2021-10-11", "shiftDateRange": "2021-10-08 - 2021-10-11", "status": "Pending", "nurseType": "CNA", "boostPercentage": 0, "location": "01", "boostable": true }, { "blockId": 286, "startDate": "2021-10-05", "endDate": "2021-10-06", "shiftDateRange": "2021-10-05 - 2021-10-06", "status": "Pending", "nurseType": "CNA", "boostPercentage": 0, "location": "01", "boostable": true }, { "blockId": 298, "startDate": "2021-10-20", "endDate": "2021-10-22", "shiftDateRange": "2021-10-20 - 2021-10-22", "status": "Pending", "nurseType": "CNA", "boostPercentage": 0, "location": "01", "boostable": true }, { "blockId": 301, "startDate": "2021-10-11", "endDate": "2021-10-15", "shiftDateRange": "2021-10-11 - 2021-10-15", "status": "Pending", "nurseType": "CNA", "boostPercentage": 0, "location": "01", "boostable": true }, { "blockId": 304, "startDate": "2021-10-18", "endDate": "2021-10-22", "shiftDateRange": "2021-10-18 - 2021-10-22", "status": "Pending", "nurseType": "CNA", "boostPercentage": 0, "location": "02", "boostable": true }, { "blockId": 313, "startDate": "2021-11-14", "endDate": "2021-11-20", "shiftDateRange": "2021-11-14 - 2021-11-20", "status": "Pending Negotiation", "nurseType": "CNA", "boostPercentage": 0, "location": "02", "boostable": true, "intelyProName": "George Smith", "intelyProImage": "https://api.dev2.intelycare.com/isystem/OPS/getImage.php?key=profimg/152336provProfimg1602000997_AF11D5D7-D7F2-ACA1-B05D-23062CCBA224.jpg", "pid": 152336 }, { "blockId": 341, "startDate": "2021-10-07", "endDate": "2021-10-14", "shiftDateRange": "2021-10-07 - 2021-10-14", "status": "Accepted", "nurseType": "Nurse", "boostPercentage": 0, "location": "02", "boostable": true, "intelyProName": "George Smith", "intelyProImage": "https://api.dev2.intelycare.com/isystem/OPS/getImage.php?key=profimg/152336provProfimg1602000997_AF11D5D7-D7F2-ACA1-B05D-23062CCBA224.jpg", "pid": 152336 }, { "blockId": 352, "startDate": "2021-10-15", "endDate": "2021-10-22", "shiftDateRange": "2021-10-15 - 2021-10-22", "status": "Pending", "nurseType": "CNA", "boostPercentage": 0, "location": "01", "boostable": true }, { "blockId": 353, "startDate": "2021-10-18", "endDate": "2021-10-22", "shiftDateRange": "2021-10-18 - 2021-10-22", "status": "Pending", "nurseType": "CNA", "boostPercentage": 0, "location": "01", "boostable": true }, { "blockId": 354, "startDate": "2021-10-14", "endDate": "2021-10-21", "shiftDateRange": "2021-10-14 - 2021-10-21", "status": "Pending", "nurseType": "CNA", "boostPercentage": 0, "location": "01", "boostable": true }, { "blockId": 355, "startDate": "2021-10-13", "endDate": "2021-10-20", "shiftDateRange": "2021-10-13 - 2021-10-20", "status": "Pending", "nurseType": "CNA", "boostPercentage": 0, "location": "01", "boostable": true }, { "blockId": 356, "startDate": "2021-10-13", "endDate": "2021-10-20", "shiftDateRange": "2021-10-13 - 2021-10-20", "status": "Pending", "nurseType": "CNA", "boostPercentage": 0, "location": "01", "boostable": true }, { "blockId": 357, "startDate": "2021-10-13", "endDate": "2021-10-20", "shiftDateRange": "2021-10-13 - 2021-10-20", "status": "Pending", "nurseType": "CNA", "boostPercentage": 0, "location": "01", "boostable": true } ], "metadata": null, "errors": null, "message": null, "status": "OK" });
    return this._http.get<JavaBaseResponse<BlockBookingsResponse[]>>(`${this.baseUri}/block/facility/${id}`, { params }).pipe(
      catchError(error => {
        this._snackbar.open('An error has occured. Please try again at a later time.', 'X', {
          duration: 3000
        });
        return throwError(error);
      })
    );
  }
  /**
   *  Get list of next {hours} open shifts.
   * @param hours : hours
   * @param cid : client id
   */
  getNextOpenShifts(hours: number, cid: number): Observable<PerformanceSummaryShift> {
    return this.metricsApi('open/next', cid, hours);
  }

  /**
   *  Get list of next {hours} released shifts.
   * @param hours : hours
   * @param cid : client id
   */
  getNextReleasedShifts(hours: number, cid: number): Observable<PerformanceSummaryShift> {
    return this.metricsApi('released/span/12/back/3/forward', cid, hours);
  }

  /**
   *  API call to get count of text messages on dashboard for the span of a month.
   *  @param startDate : starting date of the month
   *  @param endDate : ending date of the month
   */
  getTextMessageCount(startDate: string, endDate: string): Observable<string> {
    const params: HttpParams = new HttpParams()
      .append('startDate', String(startDate))
      .append('endDate', String(endDate));

    return this._http.get<JavaBaseResponse<string>>(`${this.baseShiftUri}/notifications/text/shiftrequest/count`, { params }).pipe(
      map((response: JavaBaseResponse<string>) => response.data),
      catchError(error => {
        this._snackbar.open('An error has occured. Please try again at a later time.', 'X', {
          duration: 3000
        });
        return throwError(error);
      })
    );
  }

  private metricsApi(path: string, cid: number, timeframe?: number) {
    const params: HttpParams = new HttpParams().append('cid', String(cid));
    return this._http.get<JavaBaseResponse<PerformanceSummaryShift>>(`${this.baseUri}/metrics/${path}${timeframe ? `/${timeframe}` : ''}`, { params }).pipe(
      map(response => response.data),
      catchError((error: HttpErrorResponse) => {
        if (error.status === 400) {
          return of({
            shiftServiceData: [],
            metrics: {
              type: '',
              total: 0,
              used: 0,
              percentage: 0
            }
          } as PerformanceSummaryShift);
        } else {
          this._snackbar.open('An error has occured. Please try again at a later time.', 'X', {
            duration: 3000
          });
          return throwError(error);
        }
      })
    )
  }
}
